import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ChatPreviewSC = styled.div`
  min-height: 300px;
  position: relative;

  .no-entries {
    padding: 40px;
  }
`;

export const ChatPreviewItemSC = styled(Link)`
  display: flex;
  position: relative;
  align-items: center;

  padding: 16px 24px;
  margin: 16px 0;

  box-shadow: ${({ theme }) => theme.shadows.low};
  background-color: ${({ theme }) => theme.color.surface.baseline};
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s;

  &:hover {
    text-decoration: none;
    background-color: ${({ theme }) =>
      theme.createOverlayColor(theme.color.surface.baseline, 'hover')};
  }

  .chp-avatar {
    position: relative;
    margin-right: 20px;
  }

  .chp-text {
    flex-grow: 1;
  }

  .chp-title {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0;
  }

  .chp-message {
    position: relative;

    p {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      font-weight: 700;
      font-size: 14px;
      margin-bottom: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
`;
